<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 会場CSVインポート
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CCol md="8" class="offset-md-2 text-center">
                <h3>~~ 使い方 ~~</h3>
                <p class="mb-0 pb-0">1. File has headerにチェックを入れてください</p>
                <p class="mb-0 pb-0">2. CSVファイルを選択してください</p>
                <p class="mb-0 pb-0">3. 「Next」ボタンをおしてください</p>
                <p class="mb-0 pb-0">4. 各入力項目に対してCSV中のどの列が該当するか選択してください</p>
                <p class="mb-0 pb-0">5. 「登録」ボタンを押してください</p>
                <vue-csv-import v-model="parseCSV" :map-fields="csvFields"></vue-csv-import>
                <progress-bar v-if="loading" size="medium" :val="val" :text="per"/>

                <CButton v-show="parseCSV != null" size="lg" color="info" @click="createItems()">登録</CButton>
              </CCol>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
    <CModal
      title="インポート完了"
      color="secondary"
      :show.sync="confirmModal"
    >
      インポートが完了しました。試験会場管理ページに戻ります


      <template #footer>
        <CButton size="sm" color="info" @click="jumpConfirm()">OK</CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { VueCsvImport } from 'vue-csv-import';
import ProgressBar from 'vue-simple-progress'
import { mapGetters } from 'vuex';
export default {
  components: {VueCsvImport, ProgressBar},
  data() {
    return {
      record: {},
      parseCSV: null,
      loading: false,
      per: "",
      val: 10,
      confirmModal: false,
      csvFields: {
        industry_id: '業種',
        place_id: '会場番号',
        name: '会場名',
        zip: '郵便番号',
        full_address: '住所',
        country: '国',
        state: '都道府県・州'
      }
    }
  },
  methods: {
    formatData: function(label, d) {
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else if(label == "question_type") {
          return this.questionTypeLabel[d]
        } else if(label == "industry_id") {
          return this.industryLabel[d]
        } else {
          return d
        }
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    jumpConfirm: function() {
      this.$router.push('/places')
    },
    async createItems() {
      this.loading = true
      var max = this.parseCSV.length
      var num = 0
      var step = 100 / max
      for await (var q of this.parseCSV) {
        num += step
        this.val = num
        await axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/places", {"place": q}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
          }).catch(error => {
            this.errorNotify(error.response)
          })
      }
      this.confirmModal = true
    },
  },
  mounted() {
    console.log(this.parseCSV)
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>

<style scoped lang="scss">
/deep/ .vue-csv-uploader-part-one {
  text-align: center;

  .form-group {
    padding: 10px 0px;
  }
}

</style>

